/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Status_IncompleteInputs */

const en_plan_status_incomplete = /** @type {(inputs: Plan_Status_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incomplete`)
};

const es_plan_status_incomplete = /** @type {(inputs: Plan_Status_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incompleta`)
};

/**
* | output |
* | --- |
* | "Incomplete" |
*
* @param {Plan_Status_IncompleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_status_incomplete = /** @type {((inputs?: Plan_Status_IncompleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Status_IncompleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_status_incomplete(inputs)
	return en_plan_status_incomplete(inputs)
});